const resources = {
    footerLabel: 'Customer Service Chat',
    pageLabel: 'Customer Service',
    buttonLabel: 'Customer Service',
    unavailable: 'Chat not available'
};

export default function getResource(label) {
    return resources[label];
}
